(function(){
var buttonTooltipClick = document.querySelector(".tooltip-click__svg-button"),
    buttonClosetooltipClick = document.querySelector(".tooltip-click__close"),
    tooltipContent = document.querySelector(".tooltip-click__content"),
    closeDiv = document.querySelector(".close__div"),
    tooltipContentContainer = document.querySelector(".tooltip-click__content-container"),
    elements = [buttonTooltipClick, buttonClosetooltipClick];

if(buttonTooltipClick){

     setAttributes = function (el, attrs) {
         for (var key in attrs) {
             el.setAttribute(key, attrs[key]);
         }
     }

    for(var i=0;i< elements.length;i++){
        elements[i].addEventListener("click", function () {
            tooltipContent.classList.toggle("d-none");
        });  
    }

    buttonTooltipClick.addEventListener("click", function(){
        if (!tooltipContent.classList.contains("d-none")){
            setAttributes(tooltipContentContainer, {
                "tabindex": "-1",
                "aria-atomic": "true",
                "aria-live": "assertive"
            });
        }
    })

    //Close tooltip on outside click
    closeDiv.addEventListener("click", function(){
        tooltipContent.classList.add("d-none");
    });

    //With VO set focus back to tooltip icon 
    buttonClosetooltipClick.addEventListener("click", function(){
        buttonTooltipClick.focus();
    });

    //Close on escape key press for AODA
    document.addEventListener("keyup", function (event) {
        if (event.key === "Esc" || event.key === "Escape") {
        tooltipContent.classList.add("d-none");
        }   
    });
    
}
})();